import { format } from 'date-fns';

export const getFormattedTime = (time: number, timeFormat?: string): string => {
    if (!time) {
        return '';
    }

    const date = new Date(2000, 0, 1, 0, 0, 0);
    date.setSeconds(time);

    if (timeFormat) {
        return format(date, timeFormat);
    }

    return format(date, time > 3600 ? 'hh:mm:ss' : 'mm:ss');
};
